import React, { useEffect, useState } from "react";
import { Bookmark, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

type Saved = { id: string; title: string; text: string };

export function SavedMessages({ message, onPick, testId }: { message: string; onPick: (t: string) => void; testId: string }) {
  const [list, setList] = useState<Saved[]>([]);
  const [naming, setNaming] = useState(false);
  const [title, setTitle] = useState("");
  const load = () => api.get("/admin/saved-messages").then((r) => setList(r.data)).catch(() => setList([]));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.post("/admin/saved-messages", { title: title.trim(), text: message.trim() });
      toast.success("Message saved");
      setNaming(false); setTitle(""); load();
    } catch (err) { toast.error(errMsg(err)); }
  };
  const remove = async (s: Saved) => {
    if (!window.confirm(`Delete saved message "${s.title}"?`)) return;
    try { await api.delete(`/admin/saved-messages/${s.id}`); load(); } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="space-y-2" data-testid={`${testId}-saved`}>
      {list.length > 0 && (
        <div className="flex flex-wrap gap-2" data-testid={`${testId}-saved-list`}>
          {list.map((s) => (
            <span key={s.id} className="inline-flex items-center rounded-full border border-[#CBD5E1] bg-white text-xs">
              <button type="button" className="px-3 py-1 hover:text-[#1B365D]" onClick={() => onPick(s.text)} title={s.text} data-testid={`${testId}-saved-pick-${s.id}`}>{s.title}</button>
              <button type="button" className="pr-2 text-[#94A3B8] hover:text-red-600" onClick={() => remove(s)} aria-label={`Delete ${s.title}`} data-testid={`${testId}-saved-delete-${s.id}`}><Trash2 className="h-3 w-3" /></button>
            </span>
          ))}
        </div>
      )}
      {naming ? (
        <div className="flex gap-2">
          <input className="field-input flex-1" maxLength={80} autoFocus placeholder="Name it, e.g. Volunteer reminder" value={title} onChange={(e) => setTitle(e.target.value)} data-testid={`${testId}-saved-title`} />
          <button type="button" className="btn-secondary" disabled={!title.trim()} onClick={save} data-testid={`${testId}-saved-confirm`}>Save</button>
          <button type="button" className="text-xs text-[#64748B]" onClick={() => setNaming(false)} data-testid={`${testId}-saved-cancel`}>Cancel</button>
        </div>
      ) : (
        <button type="button" className="inline-flex items-center gap-1 text-xs font-medium text-[#1B365D] disabled:opacity-40" disabled={!message.trim()} onClick={() => setNaming(true)} data-testid={`${testId}-saved-add`}>
          <Bookmark className="h-3 w-3" /> Save this message for next time
        </button>
      )}
    </div>
  );
}
